<template>
  <!-- <div class="CharacterPanels"> -->
  <transition-group class="CharacterPanels" name="list-complete" tag="div">
    <div
      class="character"
      v-for="{ key } in characters"
      v-if="get(key) && getMessage(key)"
      :key="key"
    >
      <figure class="image" :style="{
        backgroundImage: url(get(key).imageKey)
      }">
        <!-- <img
          v-if="src(get(character.key).imageKey)"
          :src="src(get(character.key).imageKey)"
          draggable="false"
        > -->
      </figure>
      <p class="balloon" v-text="getMessage(key).text"></p>
    </div>
  </transition-group>
  <!-- </div> -->
</template>

<script>
import draggable from '../common/draggable'

export default {
  components: { draggable },
  computed: {
    characters() {
      return this.$store.getters['characterList/$items']
    },
    messages() {
      return this.$store.getters['messages/$items']
    },
    tableScale() {
      return this.$store.getters['local/tableScale']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    url() {
      return this.$store.getters['images/getBackgroundUrl']
    },
    get() {
      return this.$store.getters['characters/$get']
    }
    // getFromList() {
    //   return this.$store.getters['characterList/$get']
    // }
  },
  methods: {
    showDetail(key) {
      this.$store.commit('characters/$checkout', key)
    },
    getMessage(key) {
      const character = this.get(key)
      let res = null
      this.messages.slice(0, 10).forEach((message) => {
        // console.log((Date.now() - message.timestamp.toMillis()) * 0.001 );
        // console.log(message.timestamp.toDate());
        // console.log(message.timestamp.toMillis());
        // console.log(message.timestamp);

        if (
          message.from === key
          && (!message.to || message.to.length === 0)
          && message.timestamp
          // && message.timestamp.toMillis() > Date.now() - 1000 * 15
        ) {
          res = message
        }
      })
      return res
      this.messages.find((message) => {
        return (
          message.from === key
          && message.timestamp
          && message.timestamp.toMillis() > Date.now() - 1000 * 15
        )
      })
    }
  }
}
</script>

<style scoped>
.CharacterPanels {
  position: absolute;
  bottom: -15px;
  left: -15px;
  right: -15px;
  display: flex;
  justify-content: space-around;
  /* z-index: 1; */
}
.character {
  /* width: 60px;
  height: 60px; */
  /* display: flex; */
  position: relative;
  width: 200px;
  height: 300px;
  transition: all 500ms;
  /* align-items: center; */
  /* justify-content: center; */
}
.character .image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  cursor: pointer;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.8));
}
.balloon {
  padding: 10px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.character .name {
  padding: 4px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  max-width: 60px;
  width: auto;
  transform: translateX(-50%);
  text-align: center;
  font-size: 10px;
  color: #fff;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.8);
}
.list-complete-item {
  /* transition: all 500ms ease-out; */
  /* margin-right: 10px; */
  opacity: 1;
}
.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
  /* transition: none; */
}
</style>
